export const ManualStatus = {
  compoleted: "COMPLETED",
  incompleted: "INCOMPLETED",
  none: "NONE",
} as const;

export type ManualStatusType = (typeof ManualStatus)[keyof typeof ManualStatus];
